import groupApi from '@/api/group'
import orgApi from '@/api/organization'
import { group as GroupModel, organization as OrganizationModel } from '@/api/models'
import { mergeUserContext } from '@/store/helpers'

// initial state
const state = {
  allGroups: [],
  groupNames: [],
  createGroup: Object.assign({}, GroupModel),
  recentlyCreatedGroup: false,
  createGroupPending: false,
  creategroupFailure: false,
  viewGroup: Object.assign({}, GroupModel),

  editGroup: Object.assign({}, GroupModel),
  editGroupPending: false,
  groupEditFailure: false,
  recentlyUpdatedGroup: false,

  createGroupOrgPending: false,
  createGroupOrgFailure: false,
  createGroupOrgSuccess: false
}

// getters
const getters = {
  getAllGroups: state => state.allGroups,
  getRecentlyCreatedGroup: state => state.recentlyCreatedGroup,

  getCreateGroupPending: state => state.createGroupPending,
  getCreateGroup: state => state.createGroup,
  getCreategroupFailure: state => state.creategroupFailure,
  getViewgroup: state => state.viewGroup,

  getEditGroup: state => state.editGroup,
  getEditGroupPending: state => state.editGroupPending,
  getGroupEditFailure: state => state.groupEditFailure,
  getRecentlyUpdatedGroup: state => state.recentlyUpdatedGroup,

  getCreateGroupOrgPending: state => state.createGroupOrgPending,
  getCreateGroupOrgFailure: state => state.createGroupOrgFailure,
  getCreateGroupOrgSuccess: state => state.createGroupOrgSuccess
}

// actions
const actions = {

  async createGroupOrg ({ commit }, payload) {
    commit('setCreateGroupOrgPending', true)
    var response = await groupApi.addGroupOrgnization(payload)
    commit('setCreateGroupOrgPending', false)

    if (response.status !== 200) {
      console.log('Error create Group', response)
      if (response.body.details) {
        commit('setCreateGroupOrgFailure', response.body.details)
      } else {
        commit('setCreateGroupOrgFailure', response.body.message)
      }
      return
    }
    commit('setViewGroup', response.body)
    commit('setCreateGroupOrgSuccess', response.body)
  },

  // #region group CRUD
  // single View
  async getGroupView ({ commit, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await groupApi.getGroup(payload)

    if (response.status !== 200) {
      console.log('Error getting Group', response)
      return
    }
    commit('setViewGroup', response.body)
  },

  async getAllGroups ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    let response = await groupApi.getGroups(payload)
    if (response.status !== 200) {
      console.log('Error getting Groups', response)
      return
    }
    if (_.isArray(response.body) && response.body.length > 0) {
      _.forEach(response.body, element => {
        if (element.memberOrgs.length > 0) {
          var titles = element.memberOrgs.map(org => {
            if (org) {
              return org.title
            }
          })
          element.memberOrgTitles = titles.sort().join(', ')
        }
      })
    }
    commit('setAllGroups', response.body)
    return response
  },

  async validateGroupName ({commit, state, rootState}, payload) {
    var response = await groupApi.findByName(payload)
    return response.body
  },

  // Create
  async createGroup ({commit, state, rootState}, payload) {
    commit('setCreateGroupPending', true)
    var org = Object.assign({}, OrganizationModel)
    org.id = payload.defaultOrg
    org.title = payload.defaultOrgName
    org = mergeUserContext(org, rootState)
    var orgResponse = await orgApi.updateOrganization(org)

    if (orgResponse.status !== 200) {
      console.log('Error create org for Group ', orgResponse)
      if (orgResponse.body.details) {
        commit('setCreategroupFailure', orgResponse.body.details)
      } else {
        commit('setCreategroupFailure', this._vm.$utils.errorToHtml(orgResponse.body))
      }
      commit('setCreateGroupPending', false)
      return
    }

    payload.defaultOrg = orgResponse.body.id

    payload = mergeUserContext(payload, rootState)
    var response = await groupApi.createGroup(payload)
    commit('setCreateGroupPending', false)

    if (response.status !== 200) {
      console.log('Error create Group', response)
      if (response.body.details) {
        commit('setCreategroupFailure', response.body.details)
      } else {
        commit('setCreategroupFailure', this._vm.$utils.errorToHtml(response.body))
      }
      return
    }
    commit('setRecentlyCreatedGroup', response.body)
    commit('addToGroupsList', response.body)
    commit('setCreateGroup', Object.assign({}, GroupModel))
  },

  async getGroupEdit ({ commit }, payload) {
    commit('setEditGroupPending', true)
    let response = await groupApi.getGroup(payload)
    commit('setEditGroupPending', false)

    if (response.status !== 200) {
      console.log('Error create Group', response)
      if (response.body.details) {
        commit('setGroupEditFailure', response.body.details)
      } else {
        commit('setGroupEditFailure', response.body.message)
      }
      return
    }
    commit('setEditGroup', response.body)
  },

  async updatedGroup ({commit}, payload) {
    commit('setEditGroupPending', true)
    var response = await groupApi.updateGroup(payload)
    commit('setEditGroupPending', false)
    if (response.status !== 200) {
      console.log('error from group put API >>', response)
      if (response.body.details) {
        commit('setGroupEditFailure', response.body.details)
      } else {
        commit('setGroupEditFailure', this._vm.$utils.errorToHtml(response.body))
      }
      return
    }
    commit('setRecentlyUpdatedGroup', response.body)
  }
  // #endregion
}
// mutations
const mutations = {

  resetCreateGroupOrg (state) {
    state.createGroupOrgPending = false
    state.createGroupOrgFailure = false
    state.createGroupOrgSuccess = false
  },

  reseetCreateGroup (state) {
    state.createGroup = Object.assign({}, GroupModel)
    state.recentlyCreatedGroup = false
    state.createGroupPending = false
    state.creategroupFailure = false
  },

  reseetEditGroup (state) {
    state.editGroup = Object.assign({}, GroupModel)
    state.editGroupPending = false
    state.groupEditFailure = false
    state.recentlyUpdatedGroup = false
  },

  setCreateGroupOrgSuccess (state, record) {
    state.createGroupOrgSuccess = record
  },

  setCreateGroupOrgFailure (state, record) {
    state.createGroupOrgFailure = record
  },

  setCreateGroupOrgPending (state, record) {
    state.createGroupOrgPending = record
  },

  setRecentlyUpdatedGroup (state, record) {
    state.recentlyUpdatedGroup = record
  },
  setGroupEditFailure (state, record) {
    state.groupEditFailure = record
  },
  setEditGroup (state, record) {
    state.editGroup = record
  },

  setEditGroupPending (state, record) {
    state.editGroupPending = record
  },

  setViewGroup (state, record) {
    state.viewGroup = record
  },
  setCreategroupFailure (state, records) {
    state.creategroupFailure = records
  },
  setCreateGroupPending (state, records) {
    state.createGroupPending = records
  },
  setCreateGroup (state, record) {
    state.createGroup = record
  },
  setAllGroups (state, records) {
    state.allGroups = records
  },
  setRecentlyCreatedGroup (state, record) {
    state.recentlyCreatedGroup = record
  },
  addToGroupsList (state, newRecord) {
    var oldIndex = _.findIndex(state.allGroups, (r) => r._id === newRecord._id)

    if (oldIndex < 0) {
      state.allGroups.unshift(newRecord)
    } else {
      // Uh-oh - we tried to add a record that's already in our list
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/group.js